// 校验邮箱格式
const isEmpty = (value) => value == undefined || value == null || value == "";
export function checkEmail(email) {
  if (isEmpty(email) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return false;
  }
  return true;
}
